import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-md"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/88306fd4-3a9b-4b4d-9819-fcd38e3bf0f2.png" 
              alt="Lios S.r.l." 
              className="h-6 w-auto"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-12">
            <button
              onClick={() => scrollToSection('home')}
              className="text-base font-medium transition-colors hover:text-[#1A4D4D] whitespace-nowrap cursor-pointer text-[#2C2C2C]"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('chi-siamo')}
              className="text-base font-medium transition-colors hover:text-[#1A4D4D] whitespace-nowrap cursor-pointer text-[#2C2C2C]"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('servizi')}
              className="text-base font-medium transition-colors hover:text-[#1A4D4D] whitespace-nowrap cursor-pointer text-[#2C2C2C]"
            >
              Servizi
            </button>
            <button
              onClick={() => scrollToSection('prodotti')}
              className="text-base font-medium transition-colors hover:text-[#1A4D4D] whitespace-nowrap cursor-pointer text-[#2C2C2C]"
            >
              Prodotti
            </button>
            <button
              onClick={() => scrollToSection('contatti')}
              className="text-base font-medium transition-colors hover:text-[#1A4D4D] whitespace-nowrap cursor-pointer text-[#2C2C2C]"
            >
              Contatti
            </button>
          </div>

          {/* CTA Button */}
          <button
            onClick={() => scrollToSection('contatti')}
            className="hidden lg:flex items-center gap-2 bg-[#1A4D4D] text-white px-6 py-3 rounded-full font-medium hover:bg-[#2D5F5F] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Richiedi Preventivo
            <i className="ri-arrow-right-up-line"></i>
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-[#2C2C2C]"
          >
            <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-4">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-[#2C2C2C] font-medium hover:text-[#1A4D4D] cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('chi-siamo')}
              className="block w-full text-left text-[#2C2C2C] font-medium hover:text-[#1A4D4D] cursor-pointer"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('servizi')}
              className="block w-full text-left text-[#2C2C2C] font-medium hover:text-[#1A4D4D] cursor-pointer"
            >
              Servizi
            </button>
            <button
              onClick={() => scrollToSection('prodotti')}
              className="block w-full text-left text-[#2C2C2C] font-medium hover:text-[#1A4D4D] cursor-pointer"
            >
              Prodotti
            </button>
            <button
              onClick={() => scrollToSection('contatti')}
              className="block w-full text-left text-[#2C2C2C] font-medium hover:text-[#1A4D4D] cursor-pointer"
            >
              Contatti
            </button>
            <button
              onClick={() => scrollToSection('contatti')}
              className="w-full bg-[#1A4D4D] text-white px-6 py-3 rounded-full font-medium hover:bg-[#2D5F5F] transition-all whitespace-nowrap cursor-pointer"
            >
              Richiedi Preventivo
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
